import { lazy } from 'react';
import { retry } from '../../../../config/utils';

const SummaryPartner = lazy(() => retry(()=> import(/* webpackChunkName: "PartnerUploadLoan" */ "./index")));

export default SummaryPartner;